<template>
  <div ref="elementRef" class="xy-fixed-layout" :style="layoutStyleComputed">
    <xyComponent v-for="element in elements" :element="element" :key="element.uuid" :language="props.language" />
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { info, defaultProps } from './config'
import xyComponent from '@/packages/components/xy-component.vue'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const elements = ref([])

const setChildren = (nodes) => {
  if (!nodes || !nodes.length) {
    elements.value = []
    return
  }
  nodes.forEach((node) => {
    node.style = {
      ...node.style,
      position: 'absolute'
    }
  })
  elements.value = nodes
}

onMounted(() => {
  setChildren(props.element.nodes)
})

const getRectDistance = (number) => {
  const appElement = document.getElementById('app')
  const appHeight = appElement ? appElement.offsetHeight : 0 // 获取 #app 元素的高度
  const distance = number > 0 ? number * 0.5 : 0
  let adjustedDistance = 0
  // 样式单位适配
  const contentWeight = window.innerWidth || 750
  const ratio = contentWeight / 750
  if (distance) {
    adjustedDistance = appHeight > 0 ? Math.abs((distance * ratio)) : 0 // 调整 bottom 值
  }

  return adjustedDistance || 0
}

const elementRef = ref()
const calculateLayoutStyle = () => {
  const top = getRectDistance(props.top)
  const bottom = getRectDistance(props.bottom)

  if (top > 0) {
    return {
      left: props.left || 0,
      top: top ? `${top}px` : 0
    }
  }
  return {
    left: props.left || 0,
    bottom: bottom ? `${bottom}px` : 0
  }

}

// 使用计算属性来自动处理样式计算
const layoutStyleComputed = computed(() => {
  return calculateLayoutStyle()
})

</script>

<style lang="scss" scoped>
.xy-fixed-layout {
  position: fixed;
  display: block;
  overflow: hidden;
}
</style>
